<template>
  <div>
    <back-button />
    <div class="flex-item_right">
      <event-summaries />
    </div>
  </div>
</template>

<script>
import EventSummaries from "@/components/EventSummaries";
import BackButton from "@/components/BackButton";

export default {
  name: "Supplementary",
  components: {
    BackButton,
    EventSummaries
  },
  mounted() {
    window.analytics.page("Supplementary");
  }
};
</script>
